import React, { InputHTMLAttributes } from 'react';
import classnames from 'classnames';

type Props = {
	className: string;
	error?: string;
	label: string;
	onUpload: (result: FileReader['result']) => void;
} & InputHTMLAttributes<HTMLInputElement>;

const FileInput = React.forwardRef<HTMLInputElement, Props>(({ className, error, label, onUpload, ...rest }, ref) => {
	const handleFileChange = (e) => {
		const file = e.target.files[0];
		const reader = new FileReader();

		reader.onloadend = function () {
			onUpload(reader.result);
		};

		reader.readAsDataURL(file);
	};

	return (
		<div className={className}>
			{label && (
				<label className="form-label" htmlFor={rest.name}>
					{label}
				</label>
			)}

			<input
				type="file"
				ref={ref}
				onChange={handleFileChange}
				className={classnames('_w-full _p-4 _border _border-gray-500 _border-dashed form-input', { error: !!error })}
				{...rest}
			/>
			{error && <div className="form-error">{error}</div>}
		</div>
	);
});

export default FileInput;
